<template>
	<div class="goods-list">
		<form class="goods-head" action="javascript:;" data-action="$baseUrl.customerBaseUrl/action/wwim/queryGoodsGuessList">
			<input type="text" class="text" v-model="keyword" placeholder="搜索商品">
			<input type="button" value="搜索" @click="searchGoods" class="button">
		</form>
		<dl v-if="wwGoodsData.length">
			<dd v-for="obj in wwGoodsData" class="clear">
				<a class="pic" :href="obj.detail_url_recommend" target="_blank" :title="obj.title">
					<img :src="obj.pic_url" :alt="obj.title">
				</a>
				<div class="content">
					<a class="title" :href="obj.detail_url_recommend" target="_blank" :title="obj.title">{{ obj.title }}</a>
					<p class="info">库存: -　销量: {{ obj.sold_quantity }}</p>
					<p class="price">￥{{ obj.price }}</p>
					<a class="link" href="javascript:;" data-link="#httpFormat detail_url_recommend">发送链接</a>
				</div>
			</dd>
		</dl>
		<p v-else class="shift">没有相关数据！</p>
		<div v-if="$store.state.wwGoodsLoad" class="loading-animation"><div class="box"><span></span></div></div>
	</div>
</template>

<script>
export default {
	name: 'wwGoodsTpl',
	data () {
		return {
			keyword: ''
		}
	},
	computed: {
		wwGoodsData () {
			return this.$store.state.wwGoodsData;
		},
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	methods: {
		// 搜索商品
		searchGoods () {
			var self = this,
				data = {
					"buyerNick": self.currentConversation.name,
					"sessionId": self.currentConversation.id,
					"shopId": self.currentShop.id,
					"keyword": self.keyword
				};

			self.$store.commit('changeWwGoodsLoad', true);
			self.$axios.post(API_ROOT.baseUrl + '/api/wwim/queryGoodsGuessList', data).then(result => {
				if (result.code != 200) {
					alert('搜索商品失败');
					self.$store.commit('changeWwGoodsLoad', false);
				}
			}, response => {
				alert('搜索商品失败');
				self.$store.commit('changeWwGoodsLoad', false);
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/wwGoodsList.vue